<form [formGroup]="formGroup" (submit)="submit()" class="form">
  <div class="fields">
    <fip-form>
      <mat-form-field class="field">
        <mat-label>Monitor Name</mat-label>
        <input matInput type="text" formControlName="name" data-cy="name" />
      </mat-form-field>
    </fip-form>
    <div class="field-group">
      <fip-form>
        <mat-form-field class="field">
          <mat-label>Target</mat-label>
          <input
            matInput
            type="number"
            formControlName="targetPercentage"
            data-cy="target-percentage"
          />
          <span matTextSuffix>%</span>
        </mat-form-field>
      </fip-form>
      <fip-form>
        <mat-form-field class="field">
          <mat-label>Initial Query Date</mat-label>
          <input
            matInput
            [min]="today"
            [matDatepicker]="initialQueryDate"
            formControlName="initialQueryDate"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="initialQueryDate"
          ></mat-datepicker-toggle>
          <mat-datepicker #initialQueryDate></mat-datepicker>
        </mat-form-field>
      </fip-form>
    </div>
    <div class="field-group">
      <fip-form>
        <mat-form-field class="field">
          <mat-label>Recipients Group</mat-label>
          <mat-select
            formControlName="recipientsGroupId"
            data-cy="recipient-group-select"
            [fipEnableOnLoad]="recipientsGroups$"
          >
            @for (group of recipientsGroups$ | async; track group) {
              <mat-option [value]="group.rowKey">{{ group.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </fip-form>
      <fip-form>
        <mat-form-field class="field">
          <mat-label>Approvers Group</mat-label>
          <mat-select
            formControlName="approversGroupId"
            data-cy="approver-group-select"
            [fipEnableOnLoad]="approversGroups$"
          >
            @for (group of approversGroups$ | async; track group) {
              <mat-option [value]="group.rowKey">{{ group.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </fip-form>
    </div>
    <div class="field-group">
      <fip-form class="field">
        <mat-form-field
          class="field"
          [attr.disabled]="(companies$ | async)?.length === 0"
        >
          <mat-label>Company</mat-label>
          <mat-select
            data-cy="company-select"
            formControlName="companyId"
            [fipEnableOnLoad]="companies$"
          >
            @for (company of companies$ | async; track company) {
              <mat-option [value]="company.code">{{ company.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </fip-form>
      <fip-form class="field">
        <mat-form-field class="field">
          <mat-label>Technology</mat-label>
          <mat-select data-cy="technology-select" formControlName="technology">
            @for (technology of technologies; track technology) {
              <mat-option [value]="technology">{{ technology }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </fip-form>
    </div>
  </div>
  <div class="actions">
    <button
      mat-flat-button
      color="primary"
      data-cy="submit-button"
      [disabled]="formGroup.invalid"
    >
      {{ submitTitle() }}
    </button>
  </div>
</form>
